module.exports = __webpack_public_path__ + "img/9.f3f84a6e.png";